import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Car, LogOut, LayoutDashboard } from 'lucide-react';
import { getFromLocalStorage, saveToLocalStorage } from '../mock';

const Navbar = () => {
  const navigate = useNavigate();
  const currentUser = getFromLocalStorage('currentUser');

  const handleLogout = () => {
    saveToLocalStorage('currentUser', null);
    localStorage.removeItem('rememberMe');
    navigate('/');
  };

  return (
    <nav className="bg-gray-900 border-b border-gray-800 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://www.artarackaplama.com/wp-content/uploads/2023/11/art-garage-izmir-logo.png" 
              alt="Art Garage Logo" 
              className="h-12 w-auto transform transition-transform group-hover:scale-105"
            />
          </Link>

          <div className="flex items-center gap-2 sm:gap-4">
            {currentUser ? (
              <>
                <Link to={currentUser.isAdmin ? '/admin' : '/dashboard'} className="hidden sm:block">
                  <Button variant="ghost" className="text-gray-300 hover:text-white hover:bg-gray-800">
                    <LayoutDashboard className="h-4 w-4 mr-2" />
                    {currentUser.isAdmin ? 'Admin Panel' : 'Panelim'}
                  </Button>
                </Link>
                {!currentUser.isAdmin && (
                  <Link to="/profile" className="hidden sm:block">
                    <Button variant="ghost" className="text-gray-300 hover:text-white hover:bg-gray-800">
                      <LayoutDashboard className="h-4 w-4 mr-2" />
                      Profilim
                    </Button>
                  </Link>
                )}
                <div className="hidden md:block text-xs sm:text-sm text-gray-400">
                  Hoş geldin, <span className="text-brand font-semibold">{currentUser.name}</span>
                </div>
                <Button 
                  onClick={handleLogout}
                  variant="outline" 
                  size="sm"
                  className="border-gray-700 text-gray-300 hover:bg-red-600 hover:text-white hover:border-red-600 transition-all"
                >
                  <LogOut className="h-4 w-4 sm:mr-2" />
                  <span className="hidden sm:inline">Çıkış</span>
                </Button>
              </>
            ) : (
              <>
                <Link to="/login">
                  <Button variant="ghost" size="sm" className="text-gray-300 hover:text-white hover:bg-gray-800">
                    Giriş Yap
                  </Button>
                </Link>
                <Link to="/register">
                  <Button size="sm" className="bg-gradient-to-r from-brand to-brand hover:from-brand hover:to-brand/90 text-white">
                    Kayıt Ol
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;